"use client";
import { jsx } from "react/jsx-runtime";
import { MultiSelect } from "../../../components/inputs/dropdowns/MultiSelect.js";
import { SingleSelect } from "../../../components/inputs/dropdowns/SingleSelect.js";
import { Checkbox } from "../../../components/actions/selectionControls/Checkbox.js";
import { TextArea } from "../../../components/inputs/textFields/TextArea.js";
import { TextField } from "../../../components/inputs/textFields/TextField.js";
import { useLanguage } from "../../../translations/LocalizationProvider.js";
import "../../validation/validators.js";
import { addNecessityIndicator } from "../../validation/validation.js";
import { useForm } from "../formContext.js";
import { useFormProps } from "../useFormProps.js";
function FormTextField(originalProps) {
  const props = useFormProps(originalProps, (event) => event.target.value);
  return jsx(TextField, { ...props });
}
function FormTextArea(originalProps) {
  const props = useFormProps(originalProps, (event) => event.target.value);
  return jsx(TextArea, { ...props });
}
function FormCheckbox(originalProps) {
  const props = useFormProps(originalProps, (event) => event.target.checked);
  return jsx(Checkbox, { ...props, canShowErrorMessage: true });
}
function FormSingleSelect(originalProps) {
  const formCtx = useForm();
  if (!formCtx) {
    throw new Error("FormSingleSelect must be used inside a <FormProvider />");
  }
  const lang = useLanguage();
  const { id: formId, form } = formCtx;
  const formProps = form.inputProps(originalProps.field);
  const props = {
    ...originalProps,
    id: `${formId}_${String(originalProps.field)}`,
    helperText: addNecessityIndicator(form.state.raw, form.validationConfig.validators, form.validationConfig.options.showNecessityOn, lang, originalProps.helperText, originalProps.field),
    onChange: (value) => {
      var _a;
      (_a = originalProps.onChange) == null ? void 0 : _a.call(originalProps, value);
      formProps.setValue(value);
    },
    value: formProps.value,
    validity: formProps.validity ?? originalProps.validity
  };
  return jsx(SingleSelect, { ...props });
}
function FormMultiSelect(originalProps) {
  const formCtx = useForm();
  if (!formCtx) {
    throw new Error("FormMultiSelect must be used inside a <FormProvider />");
  }
  const lang = useLanguage();
  const { id: formId, form } = formCtx;
  const formProps = form.inputProps(originalProps.field);
  const props = {
    ...originalProps,
    id: `${formId}_${String(originalProps.field)}`,
    helperText: addNecessityIndicator(form.state.raw, form.validationConfig.validators, form.validationConfig.options.showNecessityOn, lang, originalProps.helperText, originalProps.field),
    onChange: (value) => {
      var _a;
      (_a = originalProps.onChange) == null ? void 0 : _a.call(originalProps, value);
      formProps.setValue(value);
    },
    value: formProps.value,
    validity: formProps.validity ?? originalProps.validity
  };
  return jsx(MultiSelect, { ...props });
}
export {
  FormCheckbox,
  FormMultiSelect,
  FormSingleSelect,
  FormTextArea,
  FormTextField
};
